module.exports = __webpack_public_path__ + "img/portrait-rank-15@3x.9e01a87e.png";